export default "__VITE_ASSET__DFEZNloC__"